module.exports = __webpack_public_path__ + "static/media/1994_maleRate_femaleRate.2c05b455.png";